import { graphql } from '../../graphql';

export const resetPassword = graphql(`
  mutation ResetPassword($newPassword: String!, $token: String!) {
    resetPassword(input: { newPassword: $newPassword, token: $token }) {
      errors {
        message
        path
      }
      status
    }
  }
`);
